"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Search/Refined/PillMenu.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _icons = require('./icons');




















/** A pill that opens a small menu of options (the date range). */
const PillMenu = ({
  className, label, ariaLabel, value, options, onChange, footer,
}) => {
  const [open, setOpen] = _react.useState.call(void 0, false)
  const root = _react.useRef(null)

  _react.useEffect.call(void 0, () => {
    if (!open) return
    const close = (event) => {
      if (!_optionalChain([root, 'access', _ => _.current, 'optionalAccess', _2 => _2.contains, 'call', _3 => _3(event.target )])) setOpen(false)
    }
    document.addEventListener('mousedown', close)
    return () => document.removeEventListener('mousedown', close)
  }, [open])

  const toggle = _react.useCallback.call(void 0, () => setOpen(o => !o), [])

  return (
    _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'search-pill', className), ref: root, __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}
      , _react2.default.createElement('button', {
        type: "button",
        className: _classBuilder2.default.call(void 0, 'search-pill--button', open && 'search-pill--button---open'),
        'aria-haspopup': "menu",
        'aria-expanded': open,
        'aria-label': ariaLabel,
        onClick: toggle, __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}

        , label
        , _react2.default.createElement(_icons.ChevronDownIcon, { size: 14, className: "search-pill--chevron", __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}} )
      )
      , open && (
        _react2.default.createElement('div', { className: "search-pill--menu", role: "menu", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}
          , options.map(option => (
            _react2.default.createElement('button', {
              key: option.value,
              type: "button",
              role: "menuitemradio",
              'aria-checked': option.value === value,
              'aria-disabled': !!option.disabledNote,
              className: _classBuilder2.default.call(void 0, 'search-pill--option', option.disabledNote && 'search-pill--option---disabled'),
              onClick: () => {
                if (option.disabledNote) return
                setOpen(false)
                if (option.value !== value) onChange(option.value)
              }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}

              , option.icon
              , _react2.default.createElement('span', { className: "search-pill--option-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}, option.label)
              , option.disabledNote
                ? _react2.default.createElement('small', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}, option.disabledNote)
                : option.value === value && _react2.default.createElement(_icons.CheckIcon, { size: 16, className: "search-pill--check", __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}} )
            )
          ))
          , footer
        )
      )
    )
  )
}

exports. default = PillMenu
